"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsSwitch = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_hidden_input_1 = require("@hotelplan/core.basis.bs-hidden-input");
const BsSwitchWrapper = styled_components_1.default.div(({ theme }) => theme.buttons.switchButton.wrapper);
const BsSwitchLabel = styled_components_1.default.label(({ theme }) => theme.buttons.switchButton.label);
const BsSwitchInput = (_a) => {
    var { id, name, value, checked, onChange } = _a, radioProps = __rest(_a, ["id", "name", "value", "checked", "onChange"]);
    return (react_1.default.createElement(core_basis_bs_hidden_input_1.BsHiddenInput, Object.assign({ type: "radio", id: id || value, name: name, checked: checked, value: value }, radioProps, { "data-id": value, onChange: (e) => {
            onChange(e.target.value);
        } })));
};
const BsSwitch = (props) => {
    const { name, valueFirst, valueSecond, labelFirst, labelSecond, checkedValue, className, onCheck, testId = null, } = props;
    return (react_1.default.createElement(BsSwitchWrapper, { className: `bs-switch-wrapper switch-button ${className ? className : ''}`, "data-id": testId },
        react_1.default.createElement(BsSwitchInput, { value: valueFirst, checked: checkedValue === valueFirst, name: name, onChange: onCheck }),
        react_1.default.createElement(BsSwitchLabel, { "data-id": `${valueFirst}Label`, htmlFor: valueFirst }, labelFirst),
        react_1.default.createElement(BsSwitchInput, { value: valueSecond, checked: checkedValue === valueSecond, name: name, onChange: onCheck }),
        react_1.default.createElement(BsSwitchLabel, { "data-id": `${valueSecond}Label`, htmlFor: props.idSecond || valueSecond }, labelSecond)));
};
exports.BsSwitch = BsSwitch;
//# sourceMappingURL=bs-switch.js.map